import AnalyticsHelper from '../../utils/analytics-helper.js';
import SelectedDealer from '../modules/selected-dealer.js';

export default class ConfirmView {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.bas-confirm');
        this.dealer = new SelectedDealer(this, this.router);
    }

    show() {
        if (!this.router.params.has('dealer')) {
            this.router.update('search');
        } else {
            this.el.classList.remove('hide');
            this.dealer.show();
            window.scrollTo(0,0);
            this.animate();
            AnalyticsHelper.template(this.el, { dealer: this.router.params.get('dealer') });
            AnalyticsHelper.push(this.el);
        }
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        this.el.classList.remove('pre-animation');
        this.el.classList.add('apply-animation');
    }
}
